import { formatUAH } from "@bezbolisno/kit/money-format";
import type { Operational, PatientSnapshot } from "./queries";

export type Tone = "neutral" | "pos" | "warn" | "danger" | "info";

export function painTone(p: number | null): Tone {
  if (p == null) return "neutral";
  if (p <= 4) return "pos";
  if (p <= 6) return "warn";
  return "danger";
}

export const dateFmt = new Intl.DateTimeFormat("uk-UA", {
  dateStyle: "medium",
  timeStyle: "short",
});
export const nextApptFmt = new Intl.DateTimeFormat("uk-UA", {
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
});

export { isUuid } from "../../lib/ids";

export interface PackageDefOption {
  id: string;
  label: string;
}

/** Sellable package definitions labelled with their price (the DTO already filtered unpriced ones). */
export function toPackageDefOptions(defs: Operational["packageDefs"]): PackageDefOption[] {
  return defs.map((d) => ({
    id: d.id,
    label: `${d.title} · ${d.priceMinor != null ? formatUAH(d.priceMinor) : ""}`,
  }));
}

export interface PatientCardData {
  id: string;
  firstName: string;
  lastName: string;
  /** "Імʼя Прізвище" as the API formats it. */
  name: string;
  status: PatientSnapshot["status"];
  sport: string | null;
  phone: string | null;
  telegram: string | null;
  instagram: string | null;
  email: string | null;
  serviceDetails: string | null;
  internalNotes: string | null;
}

export function toCardData(p: PatientSnapshot): PatientCardData {
  return {
    id: p.id,
    firstName: p.firstName,
    lastName: p.lastName,
    name: p.name,
    status: p.status,
    sport: p.sport,
    phone: p.phone,
    telegram: p.telegram,
    instagram: p.instagram,
    email: p.email,
    serviceDetails: p.serviceDetails,
    internalNotes: p.internalNotes,
  };
}
